<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Stock Transfers",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, Loader },

  data() {
    return {
      title: "Transfer Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Transfers",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.product_name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QUANTITY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        source: 0,
        product: "",
        unit: "",
        quantity: "",
        batch: "",
      },
      itemError: "",
      quantityError: "",
      unitError: "",
      totals: {
        destination: "",
        source: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        quantity: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      modeError: "",
      paidError: "",
      branchError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", ["Products", "Batches"]),
    ...mapGetters("store", ["StoreStock"]),
    ...mapGetters("general", ["Branches", "BusinessSettings"]),
    ...mapGetters("stocktransfer", ["SaveStatus", "StockTransferCart"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StockTransferCart ? this.StockTransferCart.length : 1;
    },

    computedFields() {
      let basefields = [...this.fields];
      if (this.StockTransferCart && this.StockTransferCart.length > 0) {
        if (this.GeneralSettings.track_expiries == 1) {
          const position =
            basefields.length > 0 ? basefields.length - 1 : basefields.length;
          basefields.splice(position, 0, {
            key: "batch_number",
            label: "Batch Number",
          });
        }
      }
      return basefields;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    this.totalRows = this.StockTransferCart ? this.StockTransferCart.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCart: "stocktransfer/fetchCart",
      FetchItems: "products/fetchProducts",
      FetchBranches: "general/fetchBranches",
      FetchSettings: "general/fetchBusinessSettings",
      AddCart: "stocktransfer/addToCart",
      DeleteCartItem: "stocktransfer/deleteCart",
      EditCartItems: "stocktransfer/editCart",
      SendItems: "stocktransfer/send",
      FetchStoreItems: "store/fetchStoreStock",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBatches: "products/fetchProductBatches",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    paidCommas() {
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas() {
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },

    assignArr() {
      let selectedPdt = this.Products.filter((product) => {
        return product.id == this.data.product.split(" ")[0];
      });
      if (selectedPdt.length > 0 && selectedPdt[0].units) {
        this.unitsArr = selectedPdt[0].units;
        if (this.unitsArr.length > 0) {
          this.data.unit = this.unitsArr[0].id;
        }
      }
    },

    assignStoreArr() {
      let selectedPdt = this.StoreStock.filter((product) => {
        return product.id == this.data.product.split(" ")[0];
      });
      if (selectedPdt.length > 0 && selectedPdt[0].units) {
        this.unitsArr = selectedPdt[0].units;
        if (this.unitsArr.length > 0) {
          this.data.unit = this.unitsArr[0].id;
        }
      }
    },

    checkItem() {
      if (!this.data.product) return;

      const productId = this.data.product.split(" ")[0];

      this.existingItem = this.StockTransferCart.filter(
        (item) => item.product.id == productId
      );

      this.itemError = this.existingItem.length
        ? "This Item exists already"
        : "";
    },

    resetData() {
      this.data.product = "";
      this.data.unit = "";
      this.data.quantity = "";
    },

    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEditSup(modalId) {
      this.closeModal(modalId);
      this.editsup.sup_id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.unitError = "";
      this.quantityError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.product.id;
      this.editdata.name = data.product.product_name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.product.product_name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    send() {
      this.totals.source = this.data.source;
      if (this.totals.destination == "") {
        this.branchError = "Destination Branch is required";
        return;
      } else {
        this.branchError = "";
      }
      this.SendItems(this.totals);
    },
    resetmodeError() {
      this.modeError = "";
    },
    resetBranchError() {
      this.branchError = "";
    },

    addToCart() {
      if (!this.data.product) {
        this.itemError = "Product is required";
        return;
      }

      const productId = this.data.product.split(" ")[0];

      if (!this.data.quantity) {
        this.quantityError = "Quantity is required";
        return;
      }

      if (this.existingItem.length) {
        this.itemError = "This Item exists already";
        return;
      }

      this.AddCart({
        product: productId, // ✅ CORRECT
        unit: this.data.unit,
        quantity: this.data.quantity,
        batch: this.data.batch,
        source: this.data.source,
      });

      this.resetData();
      this.focusProduct();
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });
    },

    focusProduct() {
      if (this.data.source == 0) {
        this.$refs.cartProduct1.focus();
      } else {
        this.$refs.cartProduct2.focus();
      }
    },

    nextPlease() {
      document.getElementById("input1").focus();
    },

    FetchBatchesData() {
      this.FetchBatches(this.data.product.split(" ")[0]);
    },
  },

  created() {
    this.FetchItems();
    this.FetchCart();
    this.FetchBranches();
    this.FetchSettings();
    this.FetchStoreItems();
    this.FetchGeneralSettings();
  },

  updated() {},
};
</script>

<template>
  <Layout>
    <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
      {{ business }}
    </h4>
    <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
      <em
        v-if="
          GeneralSettings.show_branchname == 1 &&
          GeneralSettings.show_businessname == 1
        "
        >-</em
      >
      {{ branch }}
    </h4>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StockTransferCart ? StockTransferCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(quantity_field)="data">
                  {{ data.item ? data.item.quantity : 0 }}
                  {{ data.item ? data.item.unit : "---" }}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      @click="showEditModal(data.item)"
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <Loader v-if="!StockTransferCart" />

            <b-form
              v-if="StockTransferCart ? StockTransferCart.length > 0 : false"
              class="mt-3"
            >
              <div class="row">
                <h3>
                  You are transfering items from
                  <span v-if="data.source == 0">Shop</span
                  ><span v-else>Store</span>
                </h3>
                <div class="col-md-4">
                  <div class="form-group">
                    <label
                      >Destination Branch
                      <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="Branches ? Branches : []"
                      v-model="totals.destination"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Branch"
                      @input="resetBranchError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="branchError">
                    <em>{{ branchError }}</em>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-3">
                    <label>Date Sent</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      v-limit-future-date
                    />
                  </div>
                </div>
                <div
                  v-if="MyUserPerm.transfer_stock == 1"
                  class="col-md-4 mt-4"
                >
                  <b-button variant="primary" class="float-end" @click="send()"
                    ><i class="fa fa-arrow-right"></i> Send Items
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">
              <div
                class="form-group mb-3"
                v-if="StockTransferCart ? StockTransferCart.length == 0 : false"
              >
                <label>Source <span class="text-danger">*</span></label>
                <div class="input-group">
                  <select class="form-control" v-model="data.source">
                    <option value="0">Shop</option>
                    <option
                      value="1"
                      v-if="
                        BusinessSettings ? BusinessSettings.store == 1 : false
                      "
                    >
                      Store
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group mb-3" v-if="data.source == 0">
                <label>Product <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  v-model="data.product"
                  ref="cartProduct1"
                  list="products"
                  placeholder="Select Product"
                  @input="
                    resetErrors(), assignArr(), checkItem(), FetchBatchesData()
                  "
                  @keyup.enter="nextPlease()"
                />
                <datalist id="products">
                  <option
                    v-for="(pdt, p) in Products"
                    :value="pdt.name3"
                    :key="p"
                  ></option>
                </datalist>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3" v-if="data.source == 1">
                <label>Product <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  v-model="data.product"
                  ref="cartProduct2"
                  list="products"
                  placeholder="Select Product"
                  @input="
                    resetErrors(),
                      assignStoreArr(),
                      checkItem(),
                      FetchBatchesData()
                  "
                  @keyup.enter="nextPlease()"
                />
                <datalist id="products">
                  <option
                    v-for="(pdt, p) in StoreStock"
                    :value="pdt.name1"
                    :key="p"
                  ></option>
                </datalist>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Quantity <span class="text-danger">*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      step="any"
                      v-model="data.quantity"
                      @input="resetErrors()"
                      @keyup.enter="addToCart()"
                      placeholder="Enter Quantity"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Unit Measure <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="data.unit"
                      option-value="id"
                      option-text="unitsym"
                      placeholder="Select Unit"
                      @input="resetErrors()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-group mb-3"
                v-if="GeneralSettings.track_expiries == 1"
              >
                <label>Batch Number<span class="text-danger"></span></label>
                <model-list-select
                  :list="Batches ? Batches : []"
                  v-model="data.batch"
                  option-value="id"
                  option-text="batch_number"
                  class="mb-3"
                  placeholder="Select Batch"
                >
                </model-list-select>
              </div>

              <div class="form-group text-center">
                <b-button @click="addToCart()" variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title class="text-primary">
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem">
      <template #modal-title class="text-danger">
        Delete {{ deletedata.name }}</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
